module.exports = __webpack_public_path__ + "img/ubuntu-brands.36e76622.svg";